import { toItemWithIdByIdx } from '@/shared/lib/utils/map/handbook'

export const RESTRICTION_WAREHOUSE = [
  { name: 'Все', value: null },
  { name: 'Учитывать только партии из наличия', value: true },
  { name: 'Не учитывать партии из наличия', value: false }
].map(toItemWithIdByIdx)
